import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const chatService = {
  // Operazioni utente sui propri canali
  getMyChannels,
  getUnreadCount,
  getMessages,
  sendMessage,
  uploadAttachment,
  markMessagesAsRead,
  archiveChannelToProfile,
  getEligibleParticipants,
  addParticipant,

  // Operazioni back-office struttura (whitelist)
  getCompanyChannels,
  getEligibleOperators,
  getEligiblePatients,
  enableChannel,
  disableChannel,
};

function getMyChannels(params = {}) {
  const sett = { headers: authHeader(), params };
  return axios
    .get("chat/channels", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getUnreadCount() {
  const sett = { headers: authHeader() };
  return axios
    .get("chat/channels/unread-count", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getMessages(channelHashid, params = {}) {
  const sett = { headers: authHeader(), params };
  return axios
    .get(`chat/channels/${channelHashid}/message`, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function sendMessage(channelHashid, payload) {
  const sett = { headers: authHeader() };
  return axios
    .post(`chat/channels/${channelHashid}/message`, payload, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function markMessagesAsRead(channelHashid, messages) {
  const sett = { headers: authHeader() };
  return axios
    .patch(`chat/channels/${channelHashid}/message`, { messages }, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function archiveChannelToProfile(channelHashid, payload = {}) {
  const sett = { headers: authHeader() };
  return axios
    .post(`chat/channels/${channelHashid}/archive`, payload, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

// Altri professionisti nel canale, oltre al titolare: chi si può aggiungere
// (medici con un proprio canale abilitato con lo stesso paziente) e l'aggiunta
function getEligibleParticipants(channelHashid) {
  const sett = { headers: authHeader() };
  return axios
    .get(`chat/channels/${channelHashid}/participants/eligible`, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function addParticipant(channelHashid, userHashid) {
  const sett = { headers: authHeader() };
  return axios
    .post(`chat/channels/${channelHashid}/participants`, { user_id: userHashid }, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getCompanyChannels(params = {}) {
  const sett = { headers: authHeader(), params };
  return axios
    .get("chat/company/channels", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getEligibleOperators() {
  const sett = { headers: authHeader() };
  return axios
    .get("chat/company/eligible-operators", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getEligiblePatients(params = {}) {
  const sett = { headers: authHeader(), params };
  return axios
    .get("chat/company/eligible-patients", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function enableChannel(payload) {
  const sett = { headers: authHeader() };
  return axios
    .post("chat/company/channels", payload, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function disableChannel(channelHashid) {
  const sett = { headers: authHeader() };
  return axios
    .patch(`chat/company/channels/${channelHashid}/disable`, {}, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function uploadAttachment(formData) {
  const headers = authHeader();
  delete headers["Content-Type"];
  delete headers["content-type"];
  const client = axios.create({
    baseURL: config.apiUrl,
    headers: headers,
  });
  return client
    .post("resources/public", formData)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}
